import { useState } from 'react';
import './ExplainerVideo.css';

export default function ExplainerVideo() {
  const [isPlaying, setIsPlaying] = useState(false);

  const features = [
    { icon: '👥', title: 'Member Management', desc: 'Onboard & track members' },
    { icon: '💳', title: 'Payment Tracking', desc: 'Secure payment processing' },
    { icon: '📊', title: 'Analytics', desc: 'Real-time insights' },
    { icon: '🔔', title: 'Notifications', desc: 'Automated reminders' },
    { icon: '💰', title: 'Disbursements', desc: 'Secure fund transfers' },
    { icon: '📱', title: 'Mobile Ready', desc: 'Access anywhere' },
  ];

  return (
    <section className="explainer-section" data-testid="explainer-video">
      <div className="explainer-container">
        <div className="explainer-content">
          <span className="explainer-badge">Welcome to ChamaLink</span>
          <h2>Your Complete Group Finance Solution</h2>
          <p>
            ChamaLink empowers benevolence groups, savings saccos, and community organizations 
            with powerful tools to manage contributions, track payments, and distribute funds securely.
          </p>

          <div className="features-mini-grid">
            {features.map((feature, idx) => (
              <div key={idx} className="feature-mini">
                <span className="feature-mini-icon">{feature.icon}</span>
                <div>
                  <strong>{feature.title}</strong>
                  <span>{feature.desc}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="cta-buttons">
            <a href="/register" className="cta-primary">
              Get Started Free
            </a>
            <a href="/login?type=member" className="cta-secondary">
              Member Login
            </a>
          </div>
        </div>

        <div className="explainer-visual">
          <div className="video-container" onClick={() => setIsPlaying(!isPlaying)}>
            {!isPlaying ? (
              <div className="video-placeholder">
                <div className="video-preview">
                  <div className="preview-content">
                    <div className="animated-logo">
                      <div className="logo-circle">
                        <span>CL</span>
                      </div>
                      <div className="logo-rings">
                        <div className="ring ring-1"></div>
                        <div className="ring ring-2"></div>
                        <div className="ring ring-3"></div>
                      </div>
                    </div>
                    <h3>ChamaLink</h3>
                    <p>Group Finance Management</p>
                  </div>
                  <div className="floating-features">
                    <div className="float-item float-1">👥 Members</div>
                    <div className="float-item float-2">💳 Payments</div>
                    <div className="float-item float-3">📊 Reports</div>
                    <div className="float-item float-4">🔔 Alerts</div>
                  </div>
                </div>
                <button className="play-button" aria-label="Play video">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </button>
                <div className="video-duration">2:30</div>
              </div>
            ) : (
              <div className="video-active">
                <div className="video-animation">
                  <div className="step-animation">
                    <div className="step active">
                      <div className="step-icon">1</div>
                      <span>Create Your Group</span>
                    </div>
                    <div className="step-line"></div>
                    <div className="step">
                      <div className="step-icon">2</div>
                      <span>Add Members</span>
                    </div>
                    <div className="step-line"></div>
                    <div className="step">
                      <div className="step-icon">3</div>
                      <span>Collect Payments</span>
                    </div>
                    <div className="step-line"></div>
                    <div className="step">
                      <div className="step-icon">4</div>
                      <span>Disburse Funds</span>
                    </div>
                  </div>
                  <p className="animation-text">
                    Setting up your group takes just minutes. Start managing your community's finances today!
                  </p>
                </div>
                <button 
                  className="close-video" 
                  onClick={(e) => { e.stopPropagation(); setIsPlaying(false); }}
                >
                  ✕ Close
                </button>
              </div>
            )}
          </div>

          <div className="trust-badges">
            <div className="badge">
              <span className="badge-icon">🔒</span>
              <span>Secure Payments</span>
            </div>
            <div className="badge">
              <span className="badge-icon">✅</span>
              <span>Trusted by 500+ Groups</span>
            </div>
            <div className="badge">
              <span className="badge-icon">💳</span>
              <span>Stripe Powered</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
